(() => {
  const storageKey = 'balneah_delivery_region';
  const dialogRoot = document.querySelector('[data-region-selector]');
  if (!dialogRoot) return;

  const dialog = dialogRoot.querySelector('.region-selector__dialog');
  const form = dialogRoot.querySelector('[data-region-cep-form]');
  const cepInput = dialogRoot.querySelector('[data-region-cep]');
  const feedback = dialogRoot.querySelector('[data-region-feedback]');
  const selected = dialogRoot.querySelector('[data-region-selected]');
  const changeButton = dialogRoot.querySelector('[data-region-change]');
  let pendingRegion = null;

  const getSelection = () => {
    try { return JSON.parse(localStorage.getItem(storageKey)); } catch (_) { return null; }
  };

  const setCookie = (value) => {
    document.cookie = `balneah_delivery_region=${encodeURIComponent(value)}; path=/; max-age=31536000; SameSite=Lax`;
  };

  const syncCart = (value) => {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: {
        'Região de entrega': value.region === 'rj' ? 'Rio de Janeiro' : 'Brasil',
        'CEP de referência': value.cep || '',
        'Cidade de referência': value.address?.city || '',
        'UF de referência': value.address?.state || ''
      } })
    }).catch(() => {});
  };

  const checkoutUrlWithCep = () => {
    const value = getSelection();
    const cep = value && value.cep && value.cep.replace(/\D/g, '');
    if (!cep) return null;
    const url = new URL('/checkout', window.location.origin);
    url.searchParams.set('checkout[shipping_address][zip]', cep);
    // A Shopify usa estes parâmetros no primeiro carregamento do checkout.
    // Número e complemento não vêm do CEP e devem ser informados pela cliente.
    const address = value.address || {};
    if (address.street) url.searchParams.set('checkout[shipping_address][address1]', address.street);
    if (address.city) url.searchParams.set('checkout[shipping_address][city]', address.city);
    if (address.state) url.searchParams.set('checkout[shipping_address][province]', address.state);
    url.searchParams.set('checkout[shipping_address][country]', 'Brazil');
    return `${url.pathname}${url.search}`;
  };

  const isCheckoutControl = (element) => {
    if (!element) return false;
    return element.matches('[name="checkout"], .bls-btn-checkout, .bls-btn-checkout-qickview, a[href*="/checkout"]');
  };

  const redirectToPrefilledCheckout = (event) => {
    const url = checkoutUrlWithCep();
    if (!url) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(url);
  };

  const applyAnnouncements = (region) => {
    // Enquanto não houver uma escolha salva, o frete nacional é a condição
    // padrão. Assim, a mensagem do RJ nunca aparece junto da do Brasil.
    const activeRegion = region === 'rj' ? 'rj' : 'br';
    document.documentElement.dataset.deliveryRegion = activeRegion;
    document.querySelectorAll('[data-market]').forEach((item) => {
      const market = item.dataset.market || 'all';
      item.hidden = market !== 'all' && market !== activeRegion;
    });
    document.querySelectorAll('.swiper-announcementBar').forEach((slider) => {
      const swiper = slider.swiper;
      if (!swiper) return;

      swiper.update();
      const slides = Array.from(swiper.slides);
      const visibleSlideIndex = slides.findIndex((slide) => !slide.hidden && slide.dataset.market === activeRegion);
      const fallbackSlideIndex = slides.findIndex((slide) => !slide.hidden);
      if (visibleSlideIndex >= 0) swiper.slideTo(visibleSlideIndex, 0, false);
      else if (fallbackSlideIndex >= 0) swiper.slideTo(fallbackSlideIndex, 0, false);
    });
    document.querySelectorAll('free-ship-progress-bar').forEach((progressBar) => {
      progressBar.init(progressBar.dataset.order, activeRegion);
    });
    window.dispatchEvent(new CustomEvent('balneah:region-change', { detail: { region: activeRegion } }));
  };

  const updateTriggers = (value) => {
    // Brasil segue como padrão para as regras de frete, mas não deve parecer
    // uma escolha feita pela cliente quando não há região salva.
    const selectedRegion = ['br', 'rj'].includes(value?.region) ? value.region : null;
    const label = selectedRegion === 'rj' ? 'Rio de Janeiro' : 'Brasil';
    document.querySelectorAll('[data-region-selector-label]').forEach((node) => { node.textContent = label; });
    document.querySelectorAll('[data-region-quick-choice]').forEach((button) => {
      const isSelected = selectedRegion !== null && button.dataset.regionQuickChoice === selectedRegion;
      button.setAttribute('aria-pressed', String(isSelected));
    });
    document.querySelectorAll('.region-selector-trigger').forEach((trigger) => {
      trigger.dataset.hasSelection = String(selectedRegion !== null);
    });
    requestAnimationFrame(() => {
      document.querySelectorAll('.region-selector-trigger').forEach((trigger) => {
        const selectedOption = trigger.querySelector('[data-region-quick-choice][aria-pressed="true"]');
        const indicator = trigger.querySelector('.region-selector-trigger__indicator');
        if (!indicator) return;
        if (!selectedOption) {
          indicator.style.width = '';
          indicator.style.height = '';
          indicator.style.left = '';
          return;
        }
        indicator.style.width = `${selectedOption.offsetWidth}px`;
        indicator.style.height = `${selectedOption.offsetHeight}px`;
        indicator.style.left = `${selectedOption.offsetLeft}px`;
      });
    });
  };

  const renderSelection = (value) => {
    if (!value) {
      selected.textContent = '';
      changeButton.hidden = true;
      return;
    }
    const label = value.region === 'rj' ? `Rio de Janeiro${value.cep ? ` · CEP ${value.cep}` : ''}` : 'Brasil';
    selected.textContent = value.cep
      ? `CEP salvo para ${label}. Ele será usado no checkout.`
      : `Região selecionada: ${label}.`;
    changeButton.hidden = false;
  };

  const save = (value) => {
    localStorage.setItem(storageKey, JSON.stringify(value));
    setCookie(value.region);
    applyAnnouncements(value.region);
    updateTriggers(value);
    renderSelection(value);
    syncCart(value);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'delivery_region_selected', delivery_region: value.region, delivery_cep: value.cep || undefined });
  };

  const open = () => {
    const value = getSelection();
    renderSelection(value);
    pendingRegion = null;
    form.hidden = true;
    feedback.textContent = '';
    dialogRoot.hidden = false;
    document.body.classList.add('region-selector-open');
    dialog.focus();
  };

  const close = () => {
    dialogRoot.hidden = true;
    document.body.classList.remove('region-selector-open');
  };

  document.querySelectorAll('[data-region-selector-open]').forEach((button) => button.addEventListener('click', open));
  document.querySelectorAll('[data-region-quick-choice]').forEach((button) => button.addEventListener('click', () => {
    save({ region: button.dataset.regionQuickChoice, cep: '' });
  }));
  dialogRoot.querySelectorAll('[data-region-selector-close]').forEach((button) => button.addEventListener('click', close));
  changeButton.addEventListener('click', () => {
    localStorage.removeItem(storageKey);
    document.cookie = 'balneah_delivery_region=; path=/; max-age=0; SameSite=Lax';
    applyAnnouncements('');
    updateTriggers(null);
    renderSelection(null);
    form.hidden = true;
  });

  dialogRoot.querySelectorAll('[data-region-choice]').forEach((button) => button.addEventListener('click', () => {
    pendingRegion = button.dataset.regionChoice;
    feedback.textContent = '';
    if (pendingRegion === 'br') {
      save({ region: 'br', cep: '' });
      close();
      return;
    }
    form.hidden = false;
    cepInput.focus();
  }));

  cepInput.addEventListener('input', () => {
    const numbers = cepInput.value.replace(/\D/g, '').slice(0, 8);
    cepInput.value = numbers.replace(/(\d{5})(\d)/, '$1-$2');
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const cep = cepInput.value.replace(/\D/g, '');
    if (cep.length !== 8) {
      feedback.textContent = 'Informe um CEP válido com 8 números.';
      return;
    }
    feedback.textContent = 'Validando CEP…';
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const address = await response.json();
      if (!response.ok || address.erro || address.uf !== 'RJ') {
        feedback.textContent = 'Este CEP não é do estado do Rio de Janeiro. Selecione Brasil para ver as condições nacionais.';
        return;
      }
      save({
        region: 'rj',
        cep: cep.replace(/(\d{5})(\d{3})/, '$1-$2'),
        address: {
          street: address.logradouro || '',
          city: address.localidade || '',
          state: address.uf || ''
        }
      });
      feedback.textContent = '';
      close();
    } catch (_) {
      feedback.textContent = 'Não foi possível validar o CEP agora. Tente novamente.';
    }
  });

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !dialogRoot.hidden) close(); });

  // O checkout da Shopify recebe o CEP como campo de endereço. A interceptação
  // cobre os botões de checkout do carrinho, minicarrinho e compra rápida.
  document.addEventListener('click', (event) => {
    const control = event.target.closest('button, input, a');
    if (isCheckoutControl(control)) redirectToPrefilledCheckout(event);
  }, true);
  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (isCheckoutControl(submitter)) redirectToPrefilledCheckout(event);
  }, true);

  const saved = getSelection();
  applyAnnouncements(saved && saved.region);
  updateTriggers(saved);

  // The indicator is sized in JavaScript. Keep the control hidden until the
  // selected option has its final font metrics, preventing a visible jump on
  // reload while web fonts finish loading.
  const revealTriggers = () => {
    updateTriggers(getSelection());
    requestAnimationFrame(() => requestAnimationFrame(() => {
      document.querySelectorAll('.region-selector-trigger').forEach((trigger) => {
        trigger.classList.add('is-ready');
      });
    }));
  };
  const fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
  Promise.race([
    fontsReady,
    new Promise((resolve) => window.setTimeout(resolve, 700))
  ]).then(revealTriggers);
})();
